var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{staticClass:"uploader",attrs:{"action":"actionUrl","before-upload":_vm.beforeUpload,"http-request":_vm.uploadToOSS,"file-list":_vm.fileList,"show-file-list":false}},[_c('el-button',{attrs:{"type":"primary","disabled":_vm.$attrs.disabled}},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" 上传EXCEL ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }